<template>
  <rhcn-drawer
    title="message.user.forgetPwd"
    description="message.user.forgetPwdTip"
    @on-close="onClose">
    <el-form label-position="top" class="form forget-pwd-form" :model="form" :rules="formRules" ref="formRef">
      <el-form-item :label="$t('message.user.loginEmail')" prop="uName">
        <el-input type="text" v-model="form.uName" maxlength="100"
          :placeholder="$t('message.validator.input', { input: $t('message.user.loginEmail').toLowerCase() })"/>
      </el-form-item>
      <el-form-item :label="$t('message.user.captcha')" prop="fillCode">
        <div class="item-button">
          <el-input type="text" v-model="form.fillCode" maxlength="100"
            :placeholder="$t('message.validator.input', { input: $t('message.user.captcha').toLowerCase() })"/>
          <div class="btn margin-left-10">
            <div v-if="captchaLeftTime === 0"><el-button @click="sendCaptcha" class="captcha-button">{{$t('message.user.sendCaptcha')}}</el-button></div>
            <div v-if="captchaLeftTime > 0" ><el-button class="captcha-button">{{$t('message.user.restTime', { time: captchaLeftTime})}}</el-button></div>
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <div class="align-right margin-top-18">
          <el-button :loading="loading" type="primary" @click="confirm">{{$t('message.common.next')}}</el-button>
        </div>
        <!-- <div class="align-right app-info-text tologin">
          <div>{{$t('message.common.unneed')}}, <router-link :to="'/user/login'">{{$t('message.user.backToLogin')}}</router-link></div>
        </div> -->
      </el-form-item>
    </el-form>
  </rhcn-drawer>
</template>
<script>
import { codeVerify, sendMail } from '@/api/common/user';
import RhcnDrawer from '@/components/drawer/index.vue';
import { EMAIL, REQUIRED } from '@/components/validation/tool/validator';

export default {
  components: { RhcnDrawer },
  data() {
    return {
      form: {
        uName: '',
        fillCode: '',
      },
      formRules: this.getFormRules(),
      captchaLeftTime: sessionStorage.getItem('captchaLeftTime') || 0, // 距离下次可发送验证码时间
      loading: false,
    };
  },
  methods: {
    sendCaptcha() { // 发送邮箱
      this.$refs.formRef.validateField('uName', (errorMsg) => {
        if (!errorMsg) {
          const loading = this.$loading();
          sendMail({ uName: this.form.uName.trim() }).then(() => {
            this.captchaLeftTime = 59;
            let timer = setInterval(() => {
              this.captchaLeftTime -= 1;
              if (this.captchaLeftTime <= 0) {
                clearInterval(timer);
                timer = null;
              }
            }, 1000);
            loading.close();
          }).catch(() => {
            loading.close();
          });
        }
      });
    },
    confirm() { // 确认提交
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.form.uName = this.form.uName.trim();
          codeVerify(this.form).then((res) => {
            this.$router.push({
              path: '/user/forget-password/reset',
              query: {
                oid: res,
                email: this.form.uName,
              },
            });
            this.loading = false;
          }).catch(() => {
            this.loading = false;
          });
        }
      });
    },
    getFormRules() {
      const validateUName = (rule, value, callback) => {
        // 必填验证
        if (REQUIRED.regExp.test(value)) {
          callback(new Error(this.$t('message.validator.input', { input: this.$t('message.user.loginEmail').toLowerCase() })));
          return;
        }
        // 邮箱格式验证
        if (!EMAIL.regExp.test(value)) {
          callback(new Error(this.$t(EMAIL.tips)));
          return;
        }
        callback();
      };
      const validateFillCode = (rule, value, callback) => {
        // 必填
        if (REQUIRED.regExp.test(value)) {
          callback(new Error(this.$t('message.validator.input', { input: this.$t('message.user.captcha').toLowerCase() })));
          return;
        }
        callback();
      };
      return {
        uName: [
          { validator: validateUName, trigger: 'change' },
        ],
        fillCode: [
          { validator: validateFillCode, trigger: 'change' },
        ],
      };
    },
    onClose() {
      this.$router.push({
        path: '/user/login',
      });
    },
  },
  created() {
    this.form.uName = decodeURIComponent(this.$route.query.email ? this.$route.query.email : '');
  },
};
</script>
<style scoped lang="scss">
@import '@/styles/unauth-right.scss';
.forget-pwd-form {
  .captcha-button {
    width: 163px;
    font-size: 14px;
  }
}
</style>
